export default __webpack_public_path__ + "static/media/Signature.c7a9a354.jpg";